var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopySelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.30005 2.15V9.05C3.30005 9.355 3.42121 9.64751 3.63688 9.86317C3.85254 10.0788 4.14505 10.2 4.45005 10.2H9.05005C9.35505 10.2 9.64755 10.0788 9.86322 9.86317C10.0789 9.64751 10.2 9.355 10.2 9.05V4.01415C10.2 3.86095 10.1694 3.70929 10.11 3.56809C10.0505 3.42689 9.96346 3.29899 9.8539 3.1919L7.94777 1.32775C7.73293 1.11768 7.4444 1.00004 7.14392 1H4.45005C4.14505 1 3.85254 1.12116 3.63688 1.33683C3.42121 1.55249 3.30005 1.845 3.30005 2.15Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.9 10.2V11.35C7.9 11.655 7.77884 11.9475 7.56317 12.1632C7.34751 12.3788 7.055 12.5 6.75 12.5H2.15C1.845 12.5 1.55249 12.3788 1.33683 12.1632C1.12116 11.9475 1 11.655 1 11.35V5.025C1 4.72 1.12116 4.42749 1.33683 4.21183C1.55249 3.99616 1.845 3.875 2.15 3.875H3.3",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySelector);
export default __webpack_public_path__ + "static/media/copy-selector.759a75bbbfd0e040fb7dd235cc44bd69.svg";
export { ForwardRef as ReactComponent };